import { render, staticRenderFns } from "./OrderPaidConfirm.vue?vue&type=template&id=0648eb39&scoped=true&"
import script from "./OrderPaidConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderPaidConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaidConfirm.vue?vue&type=style&index=0&id=0648eb39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648eb39",
  null
  
)

export default component.exports